import { Swiper } from 'swiper/bundle';

let historySlider = document.getElementById('sliderHistory');

if (historySlider) {
  initializeSwiper(historySlider);
}

function initializeSwiper(swiperInstance) {
  let sliderHistoryOptions = {
    speed: 1000,
    simulateTouch: false,
    watchSlidesProgress: true,
    navigation: {
      disabledClass: 'slider-control-disabled',
      hiddenClass: 'slider-control-hidden',
      lockClass: 'slider-control-lock',
      nextEl: '.slider-history .slider-control-next',
      prevEl: '.slider-history .slider-control-prev',
    },
    pagination: {
      progressbarFillClass: 'slider-pagination-progressbar-fill',
      el: '.slider-pagination-progressbar',
      type: 'progressbar',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
    slideVisibleClass: 'slider-item-visible',
  };

  new Swiper(swiperInstance, sliderHistoryOptions);
}

export { initializeSwiper };
